import { useMemo } from 'react';
import { useGetPermission } from './business/useNewPermisson';
import { useOrgConfigStateValue } from './business/useOrgConfig';

export const useProductKnowledgePermission = () => {
  const {
    whiteListConfig: {
      KNOWLEDGE_SINGLE_ITEM,
      ENABLE_CHAT_HISTORY,
      ENABLE_SUPPLEMENT_KNOWLEDGE,
    } = {},
  } = useOrgConfigStateValue();
  const getPermission = useGetPermission();

  return useMemo(() => {
    return (
      (KNOWLEDGE_SINGLE_ITEM && getPermission('商品知识')) ||
      ENABLE_CHAT_HISTORY ||
      (ENABLE_SUPPLEMENT_KNOWLEDGE &&
        (getPermission('提交AI回复错误问题') || getPermission('提交AI无法回复问题')))
    );
  }, [KNOWLEDGE_SINGLE_ITEM, ENABLE_CHAT_HISTORY, ENABLE_SUPPLEMENT_KNOWLEDGE, getPermission]);
};
